import { render, staticRenderFns } from "./LoginMessageBox.vue?vue&type=template&id=785293a2&"
import script from "./LoginMessageBox.vue?vue&type=script&lang=js&"
export * from "./LoginMessageBox.vue?vue&type=script&lang=js&"
import style0 from "./LoginMessageBox.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports